// extracted by mini-css-extract-plugin
module.exports = {"content":"_02712f2b3b--content--AL97H"};